export const AUTO_STOP_DISABLED_MINUTES = 0;
export const DEFAULT_AUTO_STOP_MINUTES = 10;
export const MIN_AUTO_STOP_MINUTES = 10;
export const MAX_AUTO_STOP_MINUTES = 360;

export const DEFAULT_MAINTENANCE_WINDOW_HOUR_OF_DAY = 0;
export const DEFAULT_MAINTENANCE_WINDOW_DAY_OF_WEEK = 0;
export const DEFAULT_MAINTENANCE_WINDOW_INTERVAL_WEEKS = 4;

// Auto-pause UX. Lead time is fixed rather than scaled to auto_stop_minutes; note that the
// minimum (and default) auto_stop_minutes is 10, so for a default workspace the warning fires at
// the midpoint of the idle window. This is the parameter most likely to need tuning after real
// usage, which is why it lives here as a single constant.
export const AUTO_PAUSE_WARN_LEAD_MS = 5 * 60 * 1000;
// A user counts as "active" only if they produced input within this window.
export const USER_ACTIVITY_WINDOW_MS = 5 * 60 * 1000;
// How often the guard refreshes the current workspace's status and projected pause time.
export const AUTO_PAUSE_POLL_INTERVAL_MS = 60 * 1000;
